/*
 * config.type.axios.ts
 *
 * TODO: Convert to use AxiosResponse, AxiosError
 * TODO: Define mtAxiosReturn only
 *
 * Response from axios actions:
 *
 * 1. OK (Successful) response:
 * - AxiosResponse.headers: RawAxiosResponseHeaders | AxiosResponseHeaders;
 * - AxiosResponse.config: InternalAxiosRequestConfig<D>;
 * - AxiosResponse.request: any;
 * - AxiosResponse.status: 201;
 * - AxiosResponse.statusText: 'Created';
 * - AxiosResponse.data.xxx: (any other dto being return);
 *
 * 2. Error (Exception) response: (Axios Error type definition)
 * - AxiosError.name: string;
 * - AxiosError.message?: string;
 * - AxiosError.stack?: string;
 * - AxiosError.code?: string;
 * - AxiosError.config?: InternalAxiosRequestConfig<D>
 * - AxiosError.request?: any
 * - AxiosError.response?: AxiosResponse<T, D>
 * //
 * - AxiosError.response.data.error: string;
 * - AxiosError.response.data.message: string;
 * - AxiosError.response.data.statusCode: number;
 * // e.g.
 * - AxiosError.response.data.error === 'Bad Request!'
 * - AxiosError.response.data.message === '[User (xxx) already exist!]'
 * - AxiosError.response.data.statusCode === 400
 *
 */
//
// export type mtAxiosError = {
//   error: string; // Bad Request
//   message: string[]; // Array ["pisPasswordNew must be longer than or equal to 8 characters"]
//   statusCode: number; // 400 (HTTP Status Code)
// };
//
export type mtAxiosReturn = {
  cpibIsError: boolean;
  cpisError: string;
  cpisMessage: string;
  cpinStatusCode: number;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  cpixData: any;
};
//
// TODO: Remove this data structure!!!
//
export const moAxiosReturn: mtAxiosReturn = {
  cpibIsError: false,
  cpisError: '',
  cpisMessage: '',
  cpinStatusCode: 0,
  cpixData: null,
};
//
//#end#
